const DEFAULT_MESSAGE = 'Поле не заполнено';

export const required = (msg = DEFAULT_MESSAGE) => {
    return value => ((!Array.isArray(value) && value) || (Array.isArray(value) && value.length !== 0) ? null : msg);
};
